import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { StripeService } from '../../../../services/stripe.service';
@Component({
  selector: 'app-sale-refund-picker',
  templateUrl: './sale-refund-picker.component.html',
  styleUrls: ['./sale-refund-picker.component.scss'],
})
export class SaleRefundPickerComponent  implements OnInit {

  @Input() saleRefundParent

  public paidByCard: boolean = false
  cardInfo

  constructor(private modalCtrl: ModalController, private stripeService: StripeService) { }

  ngOnInit() {
    const cardPayment = this.saleRefundParent.payments.toArray().filter(payment => { return payment.intentID != "" && payment.intentID != undefined})
    if(cardPayment.length > 0) {
      this.paidByCard = true
      this.cardInfo = {
        last4Digits: cardPayment[0].last4Digits,
        expDate: cardPayment[0].expDate,
        intentID: cardPayment[0].intentID,
        type: cardPayment[0].type,
        chargeID: cardPayment[0].chargeID,
        isInterac: cardPayment[0].isInterac
      }
    } 
  }

  selectMethod(refundType){
    if ( refundType == "card") {

      this.modalCtrl.dismiss({refundType: refundType, cardInfo: this.cardInfo});
    } else {

      this.modalCtrl.dismiss({refundType: refundType});
    }
  }

  onDismiss() {
    this.modalCtrl.dismiss();
  }

}
